export const inactiveOptInNudgeStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		gap: 2,
		padding: 2,
		margin: 2,
		backgroundColor: '#f6f6f6',
		borderRadius: 1,
		width: 'calc(100% - (4 * var(--mui-spacing)))'
	},
	icon: {
		height: 92,
		width: 92
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 1,
		width: '100%'
	},
	header: {
		fontWeight: 500,
		fontFamily: 'Lato',
		fontSize: 20,
		lineHeight: 1,
		color: 'text.fadedPrimary'
	},
	button: {
		backgroundColor: 'background.paper',
		fontWeight: 700
	},
	requestLink: {
		fontWeight: 400,
		fontSize: 10,
		lineHeight: 1.5,
		color: 'text.secondary',
		textDecorationColor: 'currentColor'
	}
};
